import { createSlice } from "@reduxjs/toolkit";
import { rowsPerPageJsonData } from "../utils/JsonData";

const initialState = {
  adminDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  adminSearchFilters: {
   searchText: ""
  },
  rolesDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  rolesSearchFilters: {
   searchText: ""
  },
  shiftDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  shiftSearchFilters: {
   searchText: ""
  },
  placeDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  placeSearchFilters: {
   searchText: ""
  },
}

const adminSlice = createSlice({
  name: "admin",
  initialState: initialState,
  reducers: {
    adminDatagridOptionsSuccess: (state, action) => {
      state.adminDatagridOptions = {...state.adminDatagridOptions, [action.payload.key]: action.payload.value}
    },
    adminSearchFiltersSuccess: (state, action) => {
      state.adminSearchFilters = {...state.adminSearchFilters, [action.payload.key]: action.payload.value};
    },
    rolesDataGridOptionsSuccess: (state, action) => {
      state.rolesDataGridOptions = {...state.rolesDataGridOptions, [action.payload.key]: action.payload.value}
    },
    rolesSearchFiltersSuccess: (state, action) => {
      state.rolesSearchFilters = {...state.rolesSearchFilters, [action.payload.key]: action.payload.value};
    },
    shiftDataGridOptionsSuccess: (state, action) => {
      state.shiftDataGridOptions = {...state.shiftDataGridOptions, [action.payload.key]: action.payload.value}
    },
    shiftSearchFiltersSuccess: (state, action) => {
      state.shiftSearchFilters = {...state.shiftSearchFilters, [action.payload.key]: action.payload.value};
    },
    placeDataGridOptionsSuccess: (state, action) => {
      state.placeDataGridOptions = {...state.placeDataGridOptions, [action.payload.key]: action.payload.value}
    },
    placeSearchFiltersSuccess: (state, action) => {
      state.placeSearchFilters = {...state.placeSearchFilters, [action.payload.key]: action.payload.value};
    },
    
  },
});

export const {
  adminDatagridOptionsSuccess,
  adminSearchFiltersSuccess,
  rolesDataGridOptionsSuccess,
  rolesSearchFiltersSuccess,
  shiftDataGridOptionsSuccess,
  shiftSearchFiltersSuccess,
  placeDataGridOptionsSuccess,
  placeSearchFiltersSuccess,
} = adminSlice.actions;
export default adminSlice.reducer;
